import React, { ChangeEvent } from 'react';
import { Icons } from '@/icons';

const { Search: SearchIcon } = Icons;

interface SearchProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

const Search: React.FC<SearchProps> = ({ value, onChange, placeholder }) => {
  return (
    <div className='relative w-[180px] lg:w-[360px]'>
      <SearchIcon className='w-10 h-10 absolute right-0 top-1/2 -translate-y-1/2 text-gray-400' />
      <input
        type='text'
        value={value}
        onChange={onChange}
        placeholder={placeholder ?? 'Search here'}
        className='w-full h-[56px] rounded-[16px] bg-[#F5F5F5] pl-4 pr-4 py-2 border border-black placeholder-black focus:outline-none'
      />
    </div>
  );
};

export default Search;
